import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-progress-bar',
  templateUrl: './progress-bar.component.html',
  styleUrls: ['./progress-bar.component.scss']
})
export class ProgressBarComponent {
  @Input() steps: string[] = [];
  @Input() currentStep = 0;
  @Input() isLoading = true;
  @Output() stepChanged = new EventEmitter<number>();
  @Output() nextClicked = new EventEmitter<number>();
  // @Output() nextButton = new EventEmitter<void>();
  constructor(
    private router: Router
  ) { }

  isCompleted(index: number): boolean {
    return index < this.currentStep;
  }

  isActive(index: number): boolean {
    return index === this.currentStep;
  }

  isUpcoming(index: number): boolean {
    return index > this.currentStep;
  }

  isConnectorCompleted(index: number): boolean {
    return index < this.currentStep;
  }

  goToPrevious(): void {
    if (this.currentStep > 0) {
      this.currentStep--;
      this.stepChanged.emit(this.currentStep);
    }
  }

  goToNext(): void {
    this.nextClicked.emit();
  }

  handleCancel() {
    this.router.navigate(['home/main/dashboard'])
  }
}
